import { TagGroupStrategyModule_fromInt, TagGroupStrategyModule_label, TagGroupStrategyModule_description, TagGroupModule_label, TagGroupStrategy, TagGroupStrategyModule_toInt, TagGroupModule_fromInt, TagFormat_parse, TagGroup, TagGroupModule_toInt, TagType, TagTypeModule_fromInt, ConstraintKey, RuleTypeModule_fromInt, RuleType, RuleTypeModule_toInt, CulturePreset, CulturePresetModule_toInt, CulturePresetModule_fromInt } from "../Shared/Types.js";
import { ta, t as t_4 } from "../Lang.js";
import { Tags_guestsCount, Tag_groups_title, Rules_noRules, Rules_add, Rules_custom, Common_cancel, Common_save, Rules_descriptionPlaceholder, Rules_description, Rules_hardLabel, Rules_parameter, Rules_selectTable, Rules_object, Rules_selectGuest, Rules_subject, Rules_ruleType, Rules_newRule, Common_delete, Rules_soft, Rules_hard, Rules_showAdvanced, Rules_hideAdvanced, Tooltip_weightSlider, Rules_softConstraints, Rules_weightOff, Rules_hostsPlaceholder, Rules_hosts, Tooltip_culturePreset, Rules_preset, Enum_Ruletype_maxpertable, Enum_Ruletype_excludefromtable, Enum_Ruletype_assignseat, Enum_Ruletype_assigntable, Enum_Ruletype_opposite, Enum_Ruletype_adjacent, Enum_Ruletype_keeptogether, Enum_Ruletype_keepapart, Enum_Culture_custom, Enum_Culture_american, Enum_Culture_british, Enum_Culture_chinese, Enum_Culture_french, Enum_Culture_swedish, Enum_Culture_international, Enum_Culture_International_desc, Enum_Culture_Custom_desc, Enum_Culture_American_desc, Enum_Culture_British_desc, Enum_Culture_Chinese_desc, Enum_Culture_French_desc, Enum_Culture_Swedish_desc } from "../Shared/Tr.js";
import { collect as collect_1, length, sortBy, map as map_2, isEmpty, filter, tryFind, ofArray } from "../fable_modules/fable-library-js.4.28.0/List.js";
import { map, defaultArg } from "../fable_modules/fable-library-js.4.28.0/Option.js";
import { ConstraintWeights_allConstraints, ConstraintWeights_detectPreset } from "../Pages/Event/State.js";
import { createElement } from "react";
import { numberHash, stringHash, comparePrimitives, equals, compare, int32ToString, createObj } from "../fable_modules/fable-library-js.4.28.0/Util.js";
import { sectionHeader, helpIcon, helpTooltip } from "./Components.js";
import { Msg } from "../App/Messages.js";
import { reactApi } from "../fable_modules/Feliz.2.9.0/Interop.fs.js";
import { tryParse } from "../fable_modules/fable-library-js.4.28.0/Int32.js";
import { FSharpRef } from "../fable_modules/fable-library-js.4.28.0/Types.js";
import { map as map_1, empty, append, singleton, collect, delay, toList } from "../fable_modules/fable-library-js.4.28.0/Seq.js";
import { FSharpSet__Contains, ofList } from "../fable_modules/fable-library-js.4.28.0/Set.js";
import { ofList as ofList_1, tryFind as tryFind_1 } from "../fable_modules/fable-library-js.4.28.0/Map.js";
import { List_groupBy, List_distinctBy } from "../fable_modules/fable-library-js.4.28.0/Seq2.js";
import { defaultOf } from "../fable_modules/fable-library-js.4.28.0/Util.js";
import { join } from "../fable_modules/fable-library-js.4.28.0/String.js";

function culturePresetDescription(preset) {
    const matchValue = CulturePresetModule_fromInt(preset);
    switch (matchValue.tag) {
        case 1:
            return t_4(Enum_Culture_Swedish_desc);
        case 2:
            return t_4(Enum_Culture_French_desc);
        case 3:
            return t_4(Enum_Culture_Chinese_desc);
        case 4:
            return t_4(Enum_Culture_British_desc);
        case 5:
            return t_4(Enum_Culture_American_desc);
        case 6:
            return t_4(Enum_Culture_Custom_desc);
        default:
            return t_4(Enum_Culture_International_desc);
    }
}

function culturePresetOptions() {
    return ofArray([[CulturePresetModule_toInt(new CulturePreset(0, [])), t_4(Enum_Culture_international)], [CulturePresetModule_toInt(new CulturePreset(1, [])), t_4(Enum_Culture_swedish)], [CulturePresetModule_toInt(new CulturePreset(2, [])), t_4(Enum_Culture_french)], [CulturePresetModule_toInt(new CulturePreset(3, [])), t_4(Enum_Culture_chinese)], [CulturePresetModule_toInt(new CulturePreset(4, [])), t_4(Enum_Culture_british)], [CulturePresetModule_toInt(new CulturePreset(5, [])), t_4(Enum_Culture_american)], [CulturePresetModule_toInt(new CulturePreset(6, [])), t_4(Enum_Culture_custom)]]);
}

function ruleTypeOptions() {
    return ofArray([[RuleTypeModule_toInt(new RuleType(0, [])), t_4(Enum_Ruletype_keepapart)], [RuleTypeModule_toInt(new RuleType(1, [])), t_4(Enum_Ruletype_keeptogether)], [RuleTypeModule_toInt(new RuleType(2, [])), t_4(Enum_Ruletype_adjacent)], [RuleTypeModule_toInt(new RuleType(3, [])), t_4(Enum_Ruletype_opposite)], [RuleTypeModule_toInt(new RuleType(4, [])), t_4(Enum_Ruletype_assigntable)], [RuleTypeModule_toInt(new RuleType(5, [])), t_4(Enum_Ruletype_assignseat)], [RuleTypeModule_toInt(new RuleType(6, [])), t_4(Enum_Ruletype_excludefromtable)], [RuleTypeModule_toInt(new RuleType(7, [])), t_4(Enum_Ruletype_maxpertable)]]);
}

function ruleTypeLabel(rt) {
    return defaultArg(map((tuple) => tuple[1], tryFind((tupledArg) => (tupledArg[0] === rt), ruleTypeOptions())), "Unknown");
}

function ruleNeedsTable(rt) {
    const matchValue = RuleTypeModule_fromInt(rt);
    switch (matchValue.tag) {
        case 4:
        case 6:
        case 5:
            return true;
        default:
            return false;
    }
}

function ruleNeedsParameter(rt) {
    const matchValue = RuleTypeModule_fromInt(rt);
    switch (matchValue.tag) {
        case 7:
        case 8:
            return true;
        default:
            return false;
    }
}

function ruleNeedsObject(rt) {
    const matchValue = RuleTypeModule_fromInt(rt);
    switch (matchValue.tag) {
        case 7:
        case 8:
            return false;
        default:
            return true;
    }
}

function culturePresetSection(event, weights, dispatch) {
    let elems_3, elems, elems_2, elems_1;
    const currentPreset = CulturePresetModule_toInt(ConstraintWeights_detectPreset(weights)) | 0;
    return createElement("div", createObj(ofArray([["className", "card rule-section"], (elems_3 = [createElement("div", createObj(ofArray([["className", "flex items-center gap-sm mb-1"], (elems = [createElement("h3", {
        children: t_4(Rules_preset),
    }), helpTooltip(t_4(Tooltip_culturePreset)), helpIcon(() => {
        dispatch(new Msg(268, ["04", "culture-presets"]));
    })], ["children", reactApi.Children.toArray(Array.from(elems))])]))), createElement("div", createObj(ofArray([["className", "form-group"], (elems_2 = [createElement("select", createObj(ofArray([["className", "form-input culture-preset-select"], ["value", int32ToString(currentPreset)], ["onChange", (ev) => {
        let matchValue;
        let outArg = 0;
        matchValue = [tryParse(ev.target.value, 511, false, 32, new FSharpRef(() => outArg, (v_1) => {
            outArg = (v_1 | 0);
        })), outArg];
        if (matchValue[0]) {
            dispatch(new Msg(173, [matchValue[1]]));
        }
    }], (elems_1 = toList(delay(() => collect((matchValue_1) => singleton(createElement("option", {
        value: int32ToString(matchValue_1[0]),
        children: matchValue_1[1],
    })), culturePresetOptions()))), ["children", reactApi.Children.toArray(Array.from(elems_1))])])))], ["children", reactApi.Children.toArray(Array.from(elems_2))])]))), createElement("p", {
        className: "text-sm text-muted culture-description",
        children: culturePresetDescription(currentPreset),
    })], ["children", reactApi.Children.toArray(Array.from(elems_3))])])));
}

function hostsSection() {
    let elems;
    return createElement("div", createObj(ofArray([["className", "card rule-section"], (elems = [createElement("h3", {
        className: "mb-1",
        children: t_4(Rules_hosts),
    }), createElement("p", {
        className: "text-sm text-muted",
        children: t_4(Rules_hostsPlaceholder),
    })], ["children", reactApi.Children.toArray(Array.from(elems))])])));
}

function weightSlider(name, labelKey, value, dispatch) {
    let elems_1, elems;
    const isDisabled = value === 0;
    return createElement("div", createObj(ofArray([["className", isDisabled ? "weight-slider-row weight-disabled" : "weight-slider-row"], (elems_1 = [createElement("label", {
        className: "weight-label",
        children: t_4(labelKey),
    }), createElement("div", createObj(ofArray([["className", "weight-slider-control"], (elems = [createElement("input", {
        className: "weight-slider",
        type: "range",
        min: 0,
        max: 10,
        value: int32ToString(value),
        onChange: (ev) => {
            let matchValue;
            let outArg = 0;
            matchValue = [tryParse(ev.target.value, 511, false, 32, new FSharpRef(() => outArg, (v_1) => {
                outArg = (v_1 | 0);
            })), outArg];
            if (matchValue[0]) {
                dispatch(new Msg(172, [name, matchValue[1]]));
            }
        },
    }), createElement("span", {
        className: "weight-value",
        children: isDisabled ? t_4(Rules_weightOff) : int32ToString(value),
    })], ["children", reactApi.Children.toArray(Array.from(elems))])])))], ["children", reactApi.Children.toArray(Array.from(elems_1))])])));
}

const basicConstraints = ofList(ofArray([new ConstraintKey(0, []), new ConstraintKey(1, []), new ConstraintKey(2, []), new ConstraintKey(3, []), new ConstraintKey(4, []), new ConstraintKey(10, []), new ConstraintKey(9, [])]), {
    Compare: compare,
});

function softConstraintsSection(weights, showAdvanced, dispatch) {
    let elems_4;
    const basicSliders = filter((tupledArg) => FSharpSet__Contains(basicConstraints, tupledArg[0]), ConstraintWeights_allConstraints);
    const advancedSliders = filter((tupledArg_1) => !FSharpSet__Contains(basicConstraints, tupledArg_1[0]), ConstraintWeights_allConstraints);
    return createElement("div", createObj(ofArray([["className", "card rule-section"], (elems_4 = toList(delay(() => {
        let elems;
        return append(singleton(createElement("div", createObj(ofArray([["className", "flex items-center gap-sm mb-1"], (elems = [createElement("h3", {
            children: t_4(Rules_softConstraints),
        }), helpTooltip(t_4(Tooltip_weightSlider)), helpIcon(() => {
            dispatch(new Msg(268, ["04", "seating-preferences"]));
        })], ["children", reactApi.Children.toArray(Array.from(elems))])])))), delay(() => {
            let elems_1;
            return append(singleton(createElement("div", createObj(ofArray([["className", "weight-sliders"], (elems_1 = toList(delay(() => collect((matchValue) => {
                const name_4 = matchValue[0];
                return singleton(weightSlider(name_4, matchValue[1], defaultArg(tryFind_1(name_4, weights), 5), dispatch));
            }, basicSliders))), ["children", reactApi.Children.toArray(Array.from(elems_1))])])))), delay(() => {
                let elems_2;
                return append(singleton(createElement("button", createObj(ofArray([["className", "advanced-toggle-link"], ["onClick", (_arg_2) => {
                    dispatch(new Msg(171, []));
                }], (elems_2 = [createElement("span", {
                    children: showAdvanced ? t_4(Rules_hideAdvanced) : t_4(Rules_showAdvanced),
                }), createElement("span", {
                    className: showAdvanced ? "advanced-toggle-chevron expanded" : "advanced-toggle-chevron",
                    children: "▸",
                })], ["children", reactApi.Children.toArray(Array.from(elems_2))])])))), delay(() => {
                    let elems_3;
                    return showAdvanced ? singleton(createElement("div", createObj(ofArray([["className", "weight-sliders advanced-sliders"], (elems_3 = toList(delay(() => collect((matchValue_1) => {
                        const name_13 = matchValue_1[0];
                        return singleton(weightSlider(name_13, matchValue_1[1], defaultArg(tryFind_1(name_13, weights), 5), dispatch));
                    }, advancedSliders))), ["children", reactApi.Children.toArray(Array.from(elems_3))])])))) : empty();
                }));
            }));
        }));
    })), ["children", reactApi.Children.toArray(Array.from(elems_4))])])));
}

function ruleDescription(rule, guests, tables) {
    let desc;
    const subjectName = defaultArg(map((g_1) => (`${g_1.FirstName} ${g_1.LastName}`), tryFind((g) => (g.Id === rule.SubjectId), guests)), rule.SubjectId);
    let objectName;
    const matchValue = rule.ObjectId;
    if (matchValue == null) {
        objectName = "";
    }
    else {
        const objId = matchValue;
        objectName = (ruleNeedsTable(rule.RuleType) ? defaultArg(map((t_1) => t_1.Name, tryFind((t) => (t.Id === objId), tables)), objId) : defaultArg(map((g_3) => (`${g_3.FirstName} ${g_3.LastName}`), tryFind((g_2) => (g_2.Id === objId), guests)), objId));
    }
    const matchValue_1 = rule.Description;
    let matchResult, desc_1;
    if (matchValue_1 != null) {
        if ((desc = matchValue_1, desc.trim() !== "")) {
            matchResult = 0;
            desc_1 = matchValue_1;
        }
        else {
            matchResult = 1;
        }
    }
    else {
        matchResult = 1;
    }
    switch (matchResult) {
        case 0:
            return desc_1;
        default: {
            const rtLabel = ruleTypeLabel(rule.RuleType);
            if (objectName !== "") {
                return `${rtLabel}: ${subjectName} / ${objectName}`;
            }
            else {
                const matchValue_2 = rule.Parameter;
                if (matchValue_2 == null) {
                    return `${rtLabel}: ${subjectName}`;
                }
                else {
                    return `${rtLabel}: ${subjectName} (param: ${matchValue_2})`;
                }
            }
        }
    }
}

function ruleItem(rule, guests, tables, dispatch) {
    let elems, children;
    return createElement("div", createObj(ofArray([["className", "relationship-item"], (elems = [(children = ofArray([createElement("span", {
        className: "relationship-name",
        children: ruleDescription(rule, guests, tables),
    }), createElement("span", {
        className: "text-sm text-muted",
        children: `${ruleTypeLabel(rule.RuleType)} | ${rule.IsHard ? t_4(Rules_hard) : t_4(Rules_soft)}`,
    })]), createElement("div", {
        children: reactApi.Children.toArray(Array.from(children)),
    })), createElement("button", {
        className: "btn btn-sm btn-danger",
        children: t_4(Common_delete),
        onClick: (_arg) => {
            dispatch(new Msg(169, [rule.Id]));
        },
    })], ["children", reactApi.Children.toArray(Array.from(elems))])])));
}

function ruleFormView(form, guests, tables, dispatch) {
    let elems_14;
    return createElement("div", createObj(ofArray([["className", "card rule-form"], (elems_14 = toList(delay(() => append(singleton(createElement("h3", {
        className: "mb-1",
        children: t_4(Rules_newRule),
    })), delay(() => {
        let matchValue;
        return append((matchValue = form.Error, (matchValue == null) ? (empty()) : singleton(createElement("div", {
            className: "error-message",
            children: matchValue,
        }))), delay(() => {
            let elems_4, elems_1, elems, elems_3, elems_2;
            return append(singleton(createElement("div", createObj(ofArray([["className", "form-row"], (elems_4 = [createElement("div", createObj(ofArray([["className", "form-group"], (elems_1 = [createElement("label", {
                children: t_4(Rules_ruleType),
            }), createElement("select", createObj(ofArray([["className", "form-input"], ["value", int32ToString(form.RuleType)], ["onChange", (ev) => {
                let matchValue_1;
                let outArg = 0;
                matchValue_1 = [tryParse(ev.target.value, 511, false, 32, new FSharpRef(() => outArg, (v_1) => {
                    outArg = (v_1 | 0);
                })), outArg];
                if (matchValue_1[0]) {
                    dispatch(new Msg(161, [matchValue_1[1]]));
                }
            }], (elems = toList(delay(() => collect((matchValue_2) => singleton(createElement("option", {
                value: int32ToString(matchValue_2[0]),
                children: matchValue_2[1],
            })), ruleTypeOptions()))), ["children", reactApi.Children.toArray(Array.from(elems))])])))], ["children", reactApi.Children.toArray(Array.from(elems_1))])]))), createElement("div", createObj(ofArray([["className", "form-group"], (elems_3 = [createElement("label", {
                children: t_4(Rules_subject),
            }), createElement("select", createObj(ofArray([["className", "form-input"], ["value", form.SubjectId], ["onChange", (ev_1) => {
                dispatch(new Msg(162, [ev_1.target.value]));
            }], (elems_2 = toList(delay(() => append(singleton(createElement("option", {
                value: "",
                children: t_4(Rules_selectGuest),
            })), delay(() => map_1((guest) => createElement("option", {
                value: guest.Id,
                children: `${guest.FirstName} ${guest.LastName}`,
            }), guests))))), ["children", reactApi.Children.toArray(Array.from(elems_2))])])))], ["children", reactApi.Children.toArray(Array.from(elems_3))])])))], ["children", reactApi.Children.toArray(Array.from(elems_4))])])))), delay(() => {
                let elems_7;
                return append(ruleNeedsObject(form.RuleType) ? singleton(createElement("div", createObj(ofArray([["className", "form-group"], (elems_7 = toList(delay(() => append(singleton(createElement("label", {
                    children: t_4(Rules_object),
                })), delay(() => {
                    let elems_5, elems_6;
                    return ruleNeedsTable(form.RuleType) ? singleton(createElement("select", createObj(ofArray([["className", "form-input"], ["value", form.ObjectId], ["onChange", (ev_2) => {
                        dispatch(new Msg(163, [ev_2.target.value]));
                    }], (elems_5 = toList(delay(() => append(singleton(createElement("option", {
                        value: "",
                        children: t_4(Rules_selectTable),
                    })), delay(() => map_1((table) => createElement("option", {
                        value: table.Id,
                        children: table.Name,
                    }), tables))))), ["children", reactApi.Children.toArray(Array.from(elems_5))])])))) : singleton(createElement("select", createObj(ofArray([["className", "form-input"], ["value", form.ObjectId], ["onChange", (ev_3) => {
                        dispatch(new Msg(163, [ev_3.target.value]));
                    }], (elems_6 = toList(delay(() => append(singleton(createElement("option", {
                        value: "",
                        children: t_4(Rules_selectGuest),
                    })), delay(() => map_1((guest_1) => createElement("option", {
                        value: guest_1.Id,
                        children: `${guest_1.FirstName} ${guest_1.LastName}`,
                    }), guests))))), ["children", reactApi.Children.toArray(Array.from(elems_6))])]))));
                })))), ["children", reactApi.Children.toArray(Array.from(elems_7))])])))) : empty(), delay(() => {
                    let elems_8;
                    return append(ruleNeedsParameter(form.RuleType) ? singleton(createElement("div", createObj(ofArray([["className", "form-group"], (elems_8 = [createElement("label", {
                        children: t_4(Rules_parameter),
                    }), createElement("input", {
                        className: "form-input",
                        inputMode: "numeric",
                        pattern: "[0-9]*",
                        defaultValue: form.Parameter,
                        onChange: (ev_4) => {
                            dispatch(new Msg(164, [ev_4.target.value]));
                        },
                    })], ["children", reactApi.Children.toArray(Array.from(elems_8))])])))) : empty(), delay(() => {
                        let elems_12, elems_10, elems_9, elems_11;
                        return append(singleton(createElement("div", createObj(ofArray([["className", "form-row"], (elems_12 = [createElement("div", createObj(ofArray([["className", "form-group"], (elems_10 = [createElement("label", createObj(ofArray([["className", "checkbox-label"], (elems_9 = [createElement("input", {
                            type: "checkbox",
                            checked: form.IsHard,
                            onChange: (ev_5) => {
                                dispatch(new Msg(165, [ev_5.target.checked]));
                            },
                        }), createElement("span", {
                            children: t_4(Rules_hardLabel),
                        })], ["children", reactApi.Children.toArray(Array.from(elems_9))])])))], ["children", reactApi.Children.toArray(Array.from(elems_10))])]))), createElement("div", createObj(ofArray([["className", "form-group"], (elems_11 = [createElement("label", {
                            children: t_4(Rules_description),
                        }), createElement("input", {
                            className: "form-input",
                            type: "text",
                            placeholder: t_4(Rules_descriptionPlaceholder),
                            value: form.Description,
                            onChange: (ev_6) => {
                                dispatch(new Msg(166, [ev_6.target.value]));
                            },
                        })], ["children", reactApi.Children.toArray(Array.from(elems_11))])])))], ["children", reactApi.Children.toArray(Array.from(elems_12))])])))), delay(() => {
                            let elems_13;
                            return singleton(createElement("div", createObj(ofArray([["className", "flex gap-sm mt-1"], (elems_13 = [createElement("button", {
                                className: "btn btn-primary",
                                children: t_4(Common_save),
                                disabled: form.IsSubmitting,
                                onClick: (_arg) => {
                                    dispatch(new Msg(167, []));
                                },
                            }), createElement("button", {
                                className: "btn btn-secondary",
                                children: t_4(Common_cancel),
                                onClick: (_arg_1) => {
                                    dispatch(new Msg(160, []));
                                },
                            })], ["children", reactApi.Children.toArray(Array.from(elems_13))])]))));
                        }));
                    }));
                }));
            }));
        }));
    })))), ["children", reactApi.Children.toArray(Array.from(elems_14))])])));
}

function customRulesSection(rules, guests, tables, ruleForm, dispatch) {
    let elems_1;
    return createElement("div", createObj(ofArray([["className", "card rule-section"], (elems_1 = toList(delay(() => append(singleton(sectionHeader(t_4(Rules_custom), t_4(Rules_add), () => {
        dispatch(new Msg(159, []));
    })), delay(() => {
        let elems;
        return append(isEmpty(rules) ? singleton(createElement("p", {
            className: "text-muted text-sm",
            children: t_4(Rules_noRules),
        })) : singleton(createElement("div", createObj(ofArray([["className", "relationship-list"], (elems = toList(delay(() => map_1((rule) => ruleItem(rule, guests, tables, dispatch), rules))), ["children", reactApi.Children.toArray(Array.from(elems))])])))), delay(() => {
            const matchValue = ruleForm;
            if (matchValue == null) {
                return empty();
            }
            else {
                return singleton(ruleFormView(matchValue, guests, tables, dispatch));
            }
        }));
    })))), ["children", reactApi.Children.toArray(Array.from(elems_1))])])));
}

function tagGroupStrategySection(tags, guests, strategies, dispatch) {
    let elems_7, elems, elems_6;
    const generalTagLookup = ofList_1(map_2((t_1) => [t_1.Name.toLowerCase(), [t_1.Name, t_1.TagGroup]], filter((t) => equals(TagTypeModule_fromInt(t.TagType), new TagType(0, [])), tags)), {
        Compare: comparePrimitives,
    });
    const dietaryTagNames = ofList(map_2((t_3) => t_3.Name.toLowerCase(), filter((t_2) => equals(TagTypeModule_fromInt(t_2.TagType), new TagType(1, [])), tags)), {
        Compare: comparePrimitives,
    });
    const defaultGroup = TagGroupModule_toInt(new TagGroup(5, [])) | 0;
    const groupsWithTags = sortBy((tupledArg_2) => tupledArg_2[0], map_2((tupledArg_1) => {
        const items = tupledArg_1[1];
        return [tupledArg_1[0], length(items), sortBy((n_1) => n_1.toLowerCase(), List_distinctBy((n) => n.toLowerCase(), map_2((tuple_1) => tuple_1[0], items), {
            Equals: (x_3, y_3) => (x_3 === y_3),
            GetHashCode: stringHash,
        }), {
            Compare: comparePrimitives,
        })];
    }, List_groupBy((tuple) => tuple[1], filter((tupledArg) => (tupledArg[1] >= 0), map_2((tagName) => {
        const matchValue = tryFind_1(tagName.toLowerCase(), generalTagLookup);
        if (matchValue == null) {
            if (FSharpSet__Contains(dietaryTagNames, tagName.toLowerCase())) {
                return [tagName, -1];
            }
            else {
                return [tagName, defaultGroup];
            }
        }
        else {
            return [matchValue[0], matchValue[1]];
        }
    }, collect_1((g) => TagFormat_parse(g.Tags), guests))), {
        Equals: (x_2, y_2) => (x_2 === y_2),
        GetHashCode: numberHash,
    })), {
        Compare: comparePrimitives,
    });
    if (isEmpty(groupsWithTags)) {
        return defaultOf();
    }
    else {
        return createElement("div", createObj(ofArray([["className", "card rule-section"], (elems_7 = [createElement("div", createObj(ofArray([["className", "flex items-center gap-sm mb-1"], (elems = [createElement("h3", {
            children: t_4(Tag_groups_title),
        }), helpIcon(() => {
            dispatch(new Msg(268, ["04", "tag-group-strategies"]));
        })], ["children", reactApi.Children.toArray(Array.from(elems))])]))), createElement("div", createObj(ofArray([["className", "tag-group-strategies"], (elems_6 = toList(delay(() => collect((matchValue_1) => {
            let elems_5, elems_3, elems_1, tupledArg_3, elems_2, elems_4, tupledArg_5;
            const tagNames_1 = matchValue_1[2];
            const groupInt_2 = matchValue_1[0] | 0;
            const group = TagGroupModule_fromInt(groupInt_2);
            const currentStrategy = defaultArg(tryFind_1(groupInt_2, strategies), TagGroupStrategyModule_toInt(new TagGroupStrategy(4, []))) | 0;
            const groupName = t_4(TagGroupModule_label(group));
            const tagList = join(", ", tagNames_1);
            return singleton(createElement("div", createObj(ofArray([["className", "tag-group-strategy-row"], (elems_5 = [createElement("div", createObj(ofArray([["className", "tag-group-info"], (elems_3 = [createElement("div", createObj(ofArray([["className", "tag-group-label"], (elems_1 = [createElement("span", {
                className: "tag-group-name",
                children: groupName,
            }), createElement("span", {
                className: "tag-group-count text-muted text-sm",
                children: (tupledArg_3 = Tags_guestsCount(int32ToString(matchValue_1[1])), ta(tupledArg_3[0], tupledArg_3[1])),
            })], ["children", reactApi.Children.toArray(Array.from(elems_1))])]))), createElement("div", createObj(ofArray([["className", "tag-group-tags"], (elems_2 = toList(delay(() => map_1((name_10) => createElement("span", {
                className: "tag-group-tag-badge",
                children: name_10,
            }), tagNames_1))), ["children", reactApi.Children.toArray(Array.from(elems_2))])])))], ["children", reactApi.Children.toArray(Array.from(elems_3))])]))), createElement("div", createObj(ofArray([["className", "tag-group-toggle"], (elems_4 = toList(delay(() => collect((strat) => {
                let tupledArg_4;
                const stratInt = TagGroupStrategyModule_toInt(strat) | 0;
                return singleton(createElement("button", {
                    className: "btn btn-xs tag-strategy-btn" + ((currentStrategy === stratInt) ? " btn-primary" : ""),
                    title: (tupledArg_4 = TagGroupStrategyModule_description(strat)(groupName)(tagList), ta(tupledArg_4[0], tupledArg_4[1])),
                    children: t_4(TagGroupStrategyModule_label(strat)),
                    onClick: (_arg_3) => {
                        dispatch(new Msg(235, [groupInt_2, stratInt]));
                    },
                }));
            }, [new TagGroupStrategy(0, []), new TagGroupStrategy(1, []), new TagGroupStrategy(2, []), new TagGroupStrategy(3, []), new TagGroupStrategy(4, [])]))), ["children", reactApi.Children.toArray(Array.from(elems_4))])]))), createElement("div", {
                className: "tag-group-strategy-desc text-muted text-sm",
                children: (tupledArg_5 = TagGroupStrategyModule_description(TagGroupStrategyModule_fromInt(currentStrategy))(groupName)(tagList), ta(tupledArg_5[0], tupledArg_5[1])),
            })], ["children", reactApi.Children.toArray(Array.from(elems_5))])]))));
        }, groupsWithTags))), ["children", reactApi.Children.toArray(Array.from(elems_6))])])))], ["children", reactApi.Children.toArray(Array.from(elems_7))])])));
    }
}

export function view(state, dispatch) {
    let elems;
    return createElement("div", createObj(ofArray([["className", "rule-editor-container"], (elems = toList(delay(() => append(singleton(culturePresetSection(state.Event, state.ConstraintWeights, dispatch)), delay(() => append(singleton(hostsSection()), delay(() => append(singleton(softConstraintsSection(state.ConstraintWeights, state.ShowAdvancedRules, dispatch)), delay(() => append(state.ShowAdvancedRules ? singleton(tagGroupStrategySection(state.Tags, state.Guests, state.TagGroupStrategies, dispatch)) : empty(), delay(() => singleton(customRulesSection(state.Rules, state.Guests, state.Tables, state.RuleForm, dispatch)))))))))))), ["children", reactApi.Children.toArray(Array.from(elems))])])));
}

